import React from 'react';
import { connect } from 'react-redux';
import { CAMPAIGNS_COMPARE_WITH } from '../../../constants/appConfig';
import CampaignSkeleton from '../../SkeletonUI/CampaignSkeleton/CampaignSkeleton';
import { useContainerWidth } from '../../../contexts/ContainerWidthContext';
import ViewCampaignListItem from '../ViewCampaignListItem/ViewCampaignListItemNew';
import { ViewCampaignListContainer } from './styled';

const CampaignList = (props) => {
    const compareWith = CAMPAIGNS_COMPARE_WITH;
    const contentWidth = useContainerWidth();

    const filteredCampaigns = props.campaigns.fetched
        ? props.campaigns?.data.filter((campaign) =>
              compareWith.includes(campaign.platform)
          )
        : [];

    return props.campaigns.pending ? (
        <CampaignSkeleton itemCount={2} contentWidth={contentWidth} />
    ) : filteredCampaigns.length > 0 ? (
        <ViewCampaignListContainer $contentWidth={contentWidth}>
            {filteredCampaigns.map((item, index) => (
                <ViewCampaignListItem key={index} campaign={item} />
            ))}
        </ViewCampaignListContainer>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        campaigns: state.campaigns,
    };
};

export default connect(
    mapStateToProps,
    null
)(CampaignList);
